import CalendarSquare from "assets/images/CalendarSquare";
import redDot from "assets/images/red-dot.svg";
import appointment from "assets/images/square.svg";
import classNames from "classnames";

import styles from "./AppointmentIcon.module.css";

type Props = {
  className?: string;
  isSelected: boolean;
  hasUpcoming: boolean;
};

export default function AppointmentIcon(props: Props) {
  const now = new Date();

  return (
    <div className={classNames(styles.container, props.className)}>
      {props.isSelected ? <CalendarSquare /> : <img src={appointment} alt="" />}

      {props.hasUpcoming ? (
        <img className={styles.redDot} src={redDot} alt="" />
      ) : null}
      <span
        className={classNames(
          styles.date,
          props.isSelected ? styles.selectedColor : styles.unselectedColor,
        )}
      >
        {now.getDate().toString().padStart(2, "0")}
      </span>
    </div>
  );
}
